import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Probé durante 8 años. NoFap, terapia, apps. Leí esto una vez, entendí la trampa, y no he visto pornografía en 11 meses.',
    author: 'Brandon T.'
  }, {
    quote: 'Estaba a un error de perder a mi esposa. Esto me salvó. Mi intimidad está restaurada.',
    author: 'Jason K.'
  }, {
    quote: '6 años de adicción, mi adolescencia robada. No tengo palabras para expresar mi gratitud. Soy libre.',
    author: 'Austin W.'
  }];
  return <section className="bg-dark py-24" data-id="element-129">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-131">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-center mb-16 uppercase" data-id="element-132">
            Hombres reales.{' '}
            <span className="text-accent" data-id="element-133">Resultados reales.</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-134">
            {testimonials.map((test, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-dark-card border border-dark-border rounded-xl p-8 flex flex-col" data-id="element-135">
                <div className="flex gap-1 mb-6" data-id="element-136">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-137" />)}
                </div>
                <p className="text-lg text-white mb-8 flex-grow italic" data-id="element-138">
                  "{test.quote}"
                </p>
                <p className="text-gray-400 font-bold" data-id="element-139">— {test.author}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}